import AbstractComponent from "./abstract-component";

class FooterP extends AbstractComponent {
  render() {
    const {data: text, options: {marginTop, marginBottom}} = this;

    return {
      text,
      margin: [0, marginTop, 0, marginBottom]
    }
  }

  getDefaultOptions() {
    return {
      marginTop: 4,
      marginBottom: 0
    }
  }
}

export default FooterP.asFunction();
